import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const drugAccountabilityApi = createApi({
  baseQuery,
  reducerPath: 'drugAccountabilityApi',
  endpoints: builder => ({
    getSiteInfo: builder.mutation<any, any>({
      query: ({ site_id, application }) => ({
        url: `${formatString(endPoints.DrugAccountabilityRecord.getSiteInfo, {
          key: urlKeys.site_id,
          value: site_id
        })}?application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getDrugAccountRecord: builder.mutation<any, any>({
      query: ({
        ip_name,
        site_id,
        study_id,
        country,
        application,
        module_section_related,
        parent_entity_related,
        from = -1,
        size = -1,
        data
      }) => ({
        url: `${formatString(
          endPoints.DrugAccountabilityRecord.getDrugAccontRecord,
          { key: urlKeys.ip_name, value: ip_name },
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateDARDoc: builder.mutation<any, any>({
      query: ({ event_id, country, application, data }) => ({
        url: `${formatString(endPoints.DrugAccountabilityRecord.updateDARDoc, {
          key: urlKeys.event_id,
          value: event_id
        })}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createDrugAccRecord: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.DrugAccountabilityRecord.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'POST',
        body: data
      })
    }),
    getDARNotes: builder.query<any, any>({
      query: ({ event_id }) => ({
        url: formatString(endPoints.Overview.DARNotesGetAll, { key: urlKeys.event_id, value: event_id }),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getDrugEventRecords: builder.query<any, any>({
      query: ({ site_id, study_id, country, data, application, kit_id, da_log_kit_event, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.Overview.DrugEventRecordsGetAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.kit_id, value: kit_id }
        )}?country=${country}&application=${application}&da_log_kit_event=${da_log_kit_event}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createDrugEventRecords: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, kit_id, data }) => ({
        url: `${formatString(
          endPoints.Overview.DrugEventRecordsCreate,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.kit_id, value: kit_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateDrugEventRecords: builder.mutation<any, any>({
      query: ({ id, country, application, data }) => ({
        url: `${formatString(endPoints.Overview.DrugEventRecordsUpdate, {
          key: urlKeys.id,
          value: id
        })}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),

    updateDrugKitRecords: builder.mutation<any, any>({
      query: ({ id, country, application, data }) => ({
        url: `${formatString(endPoints.DrugAccountabilityRecord.DrugKitRecrodUpdate, {
          key: urlKeys.id,
          value: id
        })}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),

    updateDrugKitDoc: builder.mutation<any, any>({
      query: ({ kit_id, country, application, data }) => ({
        url: `${formatString(endPoints.DrugAccountabilityRecord.DrugKitDocUpdate, {
          key: urlKeys.kit_id,
          value: kit_id
        })}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),

    DrugKitCreateNotes: builder.mutation<any, any>({
      query: ({ kit_id, country, application, data }) => ({
        url: `${formatString(endPoints.DrugAccountabilityRecord.DrugKitCreateNotes, {
          key: urlKeys.kit_id,
          value: kit_id
        })}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),

    GetDrugKitAllNotes: builder.query<any, any>({
      query: ({ kit_id, country, application }) => ({
        url: `${formatString(endPoints.DrugAccountabilityRecord.DrugKitGetAllNote, {
          key: urlKeys.kit_id,
          value: kit_id
        })}?country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),

    GetIPNames: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.DrugAccountabilityRecord.getIpList,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=STARTUP`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useGetSiteInfoMutation,
  useGetDrugAccountRecordMutation,
  useCreateDrugAccRecordMutation,
  useUpdateDARDocMutation,
  useLazyGetDARNotesQuery,
  useLazyGetDrugEventRecordsQuery,
  useCreateDrugEventRecordsMutation,
  useUpdateDrugEventRecordsMutation,
  useUpdateDrugKitDocMutation,
  useLazyGetDrugKitAllNotesQuery,
  useUpdateDrugKitRecordsMutation,
  useDrugKitCreateNotesMutation,
  useGetIPNamesQuery
} = drugAccountabilityApi;
